import React, { useState } from "react";

import SettingsTutorial from "../SettingsTutorial";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";

import ImageTeam from "../../../../assets/img/service/team.webp";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { getLinkedPages } from "../../../../redux/reducers/user";

import { PageVisibility } from "../../../../utils/PageVisibility";
import {
  useGetTeams,
  useRequestTeamApproval,
  useUpdateTeam,
} from "../../../../utils/useTeam";

const TeamOwnerSettingsContainer: React.FC = () => {
  const linked_pages = useAppSelector(getLinkedPages);
  const auth_token = useAppSelector(getAuthToken);
  const queryArgs = {
    auth_token: auth_token,
    per: -1,
    id: linked_pages?.team ?? null,
  };

  const {
    items: { teams },
    isLoading: getLoading,
  } = useGetTeams(queryArgs);

  const { mutateAsync, mutateLoading } = useUpdateTeam(["team", queryArgs]);
  const { requestAsync, requestLoading } = useRequestTeamApproval([
    "team",
    queryArgs,
  ]);

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id?: string) => {
    if (auth_token && id) {
      await mutateAsync({
        auth_token,
        update: {
          sonic_status: PageVisibility.NotPubliclyVisible,
        },
        id,
      });
    }
  };

  const handlePublish = async (id?: string) => {
    if (auth_token && id) {
      await requestAsync({ auth_token: auth_token, id: id });
      setIsComplete(true);
    }
  };

  const tutorial = (
    <SettingsTutorial
      img_src={ImageTeam}
      title="チーム登録とは？"
      explanation="チームのメンバー情報や実績をSELeCTに掲載できます。プロフィールと同じく、チームの情報を拡散するツールとしても便利です。"
    />
  );

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        backBarText="チーム公開申請"
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (getLoading || mutateLoading || requestLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <Settings
        type="チーム"
        description="チームを作成すると、SELeCTに掲載され、プロフィールの所属チームに設定できます。チームは複数作成することが可能なので、部門ごとにチームを分けて作成することもできます。"
        link="/mypage/team-settings/create"
        tutorial={tutorial}
        currentMenu={currentMenu}
      >
        {teams.length > 0
          ? teams.map((el, i) => (
              <SettingsItem
                key={i}
                page_type="チーム"
                id={el.id}
                img_src={el?.term.img?.thumbnail.url}
                name={el.name}
                type={{ color: el.term.color }}
                status={el.status}
                handleMenu={() =>
                  setCurrentMenu(i === currentMenu ? undefined : i)
                }
                handlePublish={handlePublish}
                handlePrivate={handlePrivate}
                edit_link={`/mypage/team-settings/${el.id}`}
                member_link={`/mypage/team_settings/member/${el.id}`}
                detail_link={`/team/${el.id}`}
                isMenuOpen={currentMenu === i ? true : false}
                isOwner={true}
                borderColorStyle={el.term.color}
              />
            ))
          : null}
      </Settings>
    );
  }
};

export default TeamOwnerSettingsContainer;
